import { defineMessages } from 'react-intl';

export default defineMessages({
  logoutTitle: {
    id: 'logout.title',
    defaultMessage: 'Log out of your Atlassian account',
  },
});
